import React, { Component } from 'react'
import { Layout, Menu, Icon } from 'antd'
import { inject, observer } from "mobx-react"
import { Provider } from "mobx-react"
import CustomRouter from '../../../stores/CustomRouter';
import NavViews from '../../../stores/NavViews';
import { Tooltip } from 'antd';
import { followTeam as followTeamApi } from '../../../api-calls/user';
import { unFollowTeam as unFollowTeamApi } from '../../../api-calls/user';

import { checkFollowingTeam as checkFollowingTeamApi } from '../../../api-calls/user';
import { FaEyeSlash, FaEye } from 'react-icons/fa';

@inject("ViewStore", "UserStore", "AuthStore")
@observer class FollowTeamBtn extends Component {
    constructor(props) {
        super(props);

        this.state = {
            loading: true,
            followed: false,
        };
        this.followTeam = this.followTeam.bind(this);
    }

    componentWillMount() {
        let teamId = this.props.teamId;
        if (this.props.AuthStore.userAuth.auth) {
            let authToken = this.props.AuthStore.userAuth.auth.accessToken;
            checkFollowingTeamApi(authToken, teamId).then((res) => {
                if (res.data == "true") {
                    this.setState({ followed: true });
                }
            });
        }
        this.setState({ loading: false });
    }

    followTeam(teamId) {
        let authToken = this.props.AuthStore.userAuth.auth.accessToken;
        this.setState({ followed: true });
        return followTeamApi(authToken, teamId).then(() => { console.log("FOLLOWED!") });
    }

    unFollowTeam(teamId) {
        let authToken = this.props.AuthStore.userAuth.auth.accessToken;
        this.setState({ followed: false });
        return unFollowTeamApi(authToken, teamId).then(() => { console.log("UNFOLLOWED!") });
    }

    render() {
        let followBtn = "";
        if (this.props.smallBtn) {
            if (this.props.AuthStore.userAuth.auth) {
                if (this.state.followed) {
                    followBtn = <Tooltip title="Remove Team from Watchlist"><button className="custom-btn-unfollow" onClick={() => this.unFollowTeam(this.props.teamId)} ><FaEyeSlash /></button></Tooltip>
                } else {
                    followBtn = <Tooltip title="Add to Watchlist"><button className="custom-btn-follow" onClick={() => this.followTeam(this.props.teamId)} ><FaEye /></button></Tooltip>
                }
            } else {
                followBtn = <Tooltip title="Login To Watchlist"><button className="custom-btn-follow"><FaEye /> Team</button></Tooltip>
            }
        } else {
            if (this.props.AuthStore.userAuth.auth) {
                if (this.state.followed) {
                    followBtn = <Tooltip title="Remove Team from Watchlist"><button className="custom-btn-unfollow" onClick={() => this.unFollowTeam(this.props.teamId)} ><FaEyeSlash /> Team</button></Tooltip>
                } else {
                    followBtn = <Tooltip title="Add to Watchlist"><button className="custom-btn-follow" onClick={() => this.followTeam(this.props.teamId)} ><FaEye /> Team</button></Tooltip>
                }
            } else {
                followBtn = <Tooltip title="Login To Watchlist"><button className="custom-btn-follow"><FaEye /> Team</button></Tooltip>
            }
        }
        return (
            <div style={this.props.smallBtn ? {display: 'inline-block', float: 'right', marginTop: '-1px'} : null}>
                {!this.state.loading ? followBtn : <Icon type="progress" />}
            </div>
        )
    }
}

export default FollowTeamBtn;



// WEBPACK FOOTER //
// ./src/components/layoutComponents/followButtons/FollowTeamBtn.js